//Product Images Swiper
window.addEventListener("load", function () {
  var swiper = new Swiper(".product-swiper", {
    autoHeight: true,
    //loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
});

//Waitlist Button / Form
let waitBtn = document.querySelector('.waitlist-btn');
let waitForm = document.querySelector('.waitlist-form');
let waitSubmit = document.querySelector('#wait-submit');
let waitInputs = waitForm.querySelector('form');
let waitConfirm = waitForm.querySelector('.confirm');
let waitError = waitForm.querySelector('.error');
let waitLink = document.querySelector('#wait-link');
let waitPName = waitLink.dataset.product;
let waitPId = waitLink.dataset.id;

waitBtn.addEventListener('click', function(event){
  event.preventDefault();
  waitForm.classList.toggle('active');
  waitForm.querySelector('input').focus();
});

waitSubmit.addEventListener('click', function(event){
  event.preventDefault();

  let waitEmail = waitForm.querySelector('.customer-email').value;
  let waitName = waitForm.querySelector(".customer-name").value;

  let emailSign = waitEmail.includes("@");
  let emailCheck = false;
  let emailName = false

  if(waitEmail != ""){
    emailCheck = true;
  }

  if(waitName != "") {
    emailName = true;
  }

  if(emailCheck && emailSign && emailName){
    waitError.classList.remove("show");
    waitConfirm.classList.add('show');
    waitInputs.classList.toggle("hide");

    let mailLink = "mailto:victoriamorrispottery@gmail.com?subject=Waitlist - " + waitPName + "&body=My%20name%20is%20" + waitName + ".%20I%20would%20like%20to%20be%20added%20to%20the%20waitlist%20for%20" + waitPName + ". You can reach me at " + waitEmail + '.%0D%0A%0D%0AProduct ID: ' + waitPId;

    waitLink.setAttribute('href', mailLink);
    waitLink.click();


  } else {
    
    waitError.classList.add('show');
  }

});